import { render } from "./TheCard.vue?vue&type=template&id=ad772b9c&scoped=true"
import script from "./TheCard.vue?vue&type=script&lang=js"
export * from "./TheCard.vue?vue&type=script&lang=js"

import "./TheCard.vue?vue&type=style&index=0&id=ad772b9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad772b9c"]])

export default __exports__